<div class="vig-footer">
  <div class="vig-footer--copyright">&copy; 2025 by Vigilant Inc. All rights reserved.</div>
  <div class="vig-footer--version">{{ buildVersion }} ({{ environmentName }})</div>
</div>
